/**
 * @namespace layout/infringement
 */

export const useStore_layout_infringement = defineStore('layout/infringement', {
  state: () => ({
    displaySigninForm: false,
    eventCaptured: false,
  }),
})
